import { render, staticRenderFns } from "./r-server-events-page.vue?vue&type=template&id=5def50fb"
import script from "./r-server-events-page.vue?vue&type=script&lang=js"
export * from "./r-server-events-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5def50fb')) {
      api.createRecord('5def50fb', component.options)
    } else {
      api.reload('5def50fb', component.options)
    }
    module.hot.accept("./r-server-events-page.vue?vue&type=template&id=5def50fb", function () {
      api.rerender('5def50fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/server-events/r-server-events-page.vue"
export default component.exports